import "ol/ol.css";
import { Style, Stroke, Fill, Text, Icon } from "ol/style.js";
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Overlay from 'ol/Overlay';
import { Chip, Avatar } from '@mui/material';
import ReactDOM from 'react-dom/client';
import ApiService from "services/ApiService";
import { setSourceForGeoJSON } from "map/OlExtension";
import "ol/ol.css";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { fromLonLat, toLonLat } from "ol/proj";
import { ToFeatures } from 'services/GeoJsonService';

export default class LayerForFutureFucMarkerHall extends VectorLayer {
    constructor(map) {
        super({
            name: "layerForFutureFucMarker",
            source: new VectorSource(),
            style: (feature) => this.getDefaultStyle(feature),
            // style: null,
        });
        this.map = map;
        this.map?.addLayer(this);
        this.setData();
    }

    // setData = function () {
    //     const layer = this;

    //     const data = [
    //         { 
    //             name: '컨벤션센터',
    //             x: 127.06022,
    //             y: 37.28556,
    //         },
    //         { 
    //             name: '도시안전통합센터',
    //             x: 127.053944,
    //             y: 37.29394,
    //         },
    //     ];

    //     const features = data.map((item, i) => {
    //         const feature = new Feature({
    //             geometry: new Point(fromLonLat([item.x, item.y])),
    //             properties: {
    //                 nm: item.name,
    //             },
    //         });
    //         feature.setId(`hall_${i}`);
    //         return feature;
    //     });

    //     // let dataset = new Array();
    //     // let id, name, x, y, obj;
    //     // for(let i = 0; i < data.length; i++) {
               
    //     //     id = 'hall_' + i;
    //     //     name = data[i]['name'];
    //     //     x = data[i]['x'];
    //     //     y = data[i]['y'];
            
    //     //     obj = { id: id, x: x, y: y, nm: name, type: "ForFutureFucMarkerHall" };
    //     //     dataset.push(obj);
    //     // }
    //     let source = this.getSource();
    //     // source.addFeatures(ToFeatures(dataset));
    //     source.addFeatures(features);

        
    //     // 각 feature에 대해 오버레이 부착
    //     features.forEach((feature) => this.addOverlayForFeature(feature));
    // };

     setData = function () {
        const layer = this;

        let dataset = new Array();
        let id, name, x, y, obj;

        obj = { 
            id: 'suwonCenter', 
            x: 127.06022,
            y: 37.28526,
            nm: '수원컨벤션센터',
            type: "poi", 
        };
        dataset.push(obj);

        obj = { 
            id: 'controlCenter', 
            x: 127.053944,
            y: 37.29454,
            nm: '교통관제센터',
            type: "poi", 
        };
        dataset.push(obj);

        const source = this.getSource()
        source.addFeatures(ToFeatures(dataset))
    }

    

    addOverlayForFeature = (feature) => {
        const coord = feature.getGeometry().getCoordinates();
        const name = feature.get("properties")?.nm;

        // Chip 컴포넌트를 위한 DOM 생성
        const container = document.createElement("div");
        container.className = "hall-chip";
        document.body.appendChild(container); // or 특정 map container 내부에 append

        ReactDOM.createRoot(container).render(
            <Chip
                avatar={
                    <Avatar
                        sx={{
                            width: '64px !important',
                            height: '64px !important',
                            fontSize: '36px !important',
                            backgroundColor: '#46B1FE !important',
                            border: '5px solid var(--white) !important',
                            marginLeft: '-6px !important'
                        }}
                    >&nbsp;</Avatar>
                }
                label={name}
                variant="outlined"
                sx={{
                    height: 56,
                    fontSize: 28,
                    fontWeight: 300,
                    backgroundColor: '#0E1327',
                    color: '#fff',
                    border: '0px',
                    borderRadius: '30px',
                    paddingRight: '16px'
                }}
            />
        );

        const overlay = new Overlay({
            element: container,
            positioning: "bottom-center",
            stopEvent: false,
        });
        overlay.setPosition(coord);
        this.map.addOverlay(overlay);
    };

    getDefaultStyle = (feature) => {
        const id = feature.get('properties')?.id ;
        return new Style({
            image: new Icon({
                anchor: [0.5, 0.5],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: `/images/dashboard/${id}.svg`,
                scale: 1.0,
            }),
            zIndex: 1,
        })
    };
}
